import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Menu',
    isTitle: true,
    link: '/events',
    permission: 'MENU',
  },
  {
    id: 2,
    label: 'Pacotes',
    icon: 'monitor',
    permission: 'PACKETS',
    subItems: [
      {
        id: 3,
        label: 'Eventos',
        link: '/packets/events',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_EVENTS',
      },
      {
        id: 4,
        label: 'Comandos',
        link: '/packets/commands',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_COMMANDS',
      },
      {
        id: 5,
        label: 'Última Posição',
        link: '/packets/lastposition',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_LASTPOSITIONS',
      },
      {
        id: 6,
        label: 'Status',
        link: '/packets/status',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_STATUS',
      },
      {
        id: 7,
        label: 'Setup Ativacao',
        link: '/packets/setupAtivacao',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_SETUP_ATIVACAO',
      },
      {
        id: 24,
        label: 'Hyundai Bluelink',
        link: '/packets/hyundaiPosition',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_HYUNDAI',
      },
      {
        id: 27,
        label: 'Comandos em lote',
        link: '/packets/batchCommands',
        parentId: 2,
        onlyAdmin: false,
        permission: 'PACKETS_COMMANDS_BATCH',
      },
    ],
  },
  {
    id: 8,
    label: 'Ferramentas',
    icon: 'tool',
    permission: 'TOOLS',
    subItems: [
      {
        id: 9,
        label: 'Utilidades',
        link: '/tools/utils',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_UTILS',
      },
      {
        id: 10,
        label: 'Fluxo de Homologação',
        link: '/tools/processFlow',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_PROCESS_FLOW',
      },
      {
        id: 11,
        label: 'Acompanhamento',
        link: '/tools/monitoring',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_MONITORING',
      },
      {
        id: 12,
        label: 'Tradutor - Maxtrack',
        link: '/tools/translateMaxtrack',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_TRANSLATE',
      },
      {
        id: 13,
        label: 'Mapas auxiliares',
        link: '/tools/map',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_MAPS_AUX',
      },
      {
        id: 14,
        label: 'Relatórios',
        link: '/tools/report',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_REPORT',
      },
      {
        id: 15,
        label: 'Comando Info',
        link: '/tools/commandInfo',
        parentId: 8,
        onlyAdmin: false,
        permission: 'TOOLS_COMMANDS_INFO',
      },
    ],
  },
  {
    id: 16,
    label: 'Outros',
    icon: 'pie-chart',
    permission: 'OTHERS',
    subItems: [
      {
        id: 17,
        label: 'Arquivos',
        link: '/other/files',
        parentId: 16,
        onlyAdmin: false,
        permission: 'OTHERS_FILES',
      },
      {
        id: 18,
        label: 'Controle de Fornecedores',
        link: '/other/supplierControl',
        parentId: 16,
        onlyAdmin: false,
        permission: 'OTHERS_SUPPLIER_CONTROL',
      },
      {
        id: 19,
        label: 'Lista Keep Alive',
        link: '/other/keepAliveFiles',
        parentId: 16,
        onlyAdmin: false,
        permission: 'OTHERS_KEEP_ALIVE_LAST_FILE',
      },
      /* {
        id: 17,
        label: 'Dashboard',
        link: '/other/dashboard',
        parentId: 13,
      },*/
    ],
  },
  {
    id: 20,
    label: 'Van Transfer',
    icon: 'truck',
    permission: 'VAN_TRANSFER',
    subItems: [
      {
        id: 21,
        label: 'Controle de Vans',
        link: '/vantransfer/vansdevices',
        parentId: 20,
        onlyAdmin: false,
        permission: 'VAN_TRANSFER_DEVICES',
      },
      {
        id: 22,
        label: 'Configuração de Rotas',
        link: '/vantransfer/vansroutes',
        parentId: 20,
        onlyAdmin: false,
        permission: 'VAN_TRANSFER_ROUTES',
      },
    ],
  },
  {
    id: 24,
    label: 'Relatórios',
    icon: 'file-text',
    permission: 'TOOLS',
    subItems: [
      {
        id: 25,
        label: 'Comandos de Emergência',
        link: '/report/emergencyCommand',
        parentId: 24,
        onlyAdmin: false,
        permission: 'TOOLS_UTILS',
      },
      {
        id: 26,
        label: 'Posições em Emergência',
        link: '/report/emergencyPosition',
        parentId: 24,
        onlyAdmin: false,
        permission: 'TOOLS_UTILS',
      },
    ],
  },
  {
    id: 23,
    label: 'Admin',
    isTitle: false,
    icon: 'user',
    link: '/admin',
    onlyAdmin: true,
    permission: 'ADMIN',
  },
];
